<script>
  // @ts-check
  import IconScale from "@sourcewhale/shared/svelte-design-system/components/atoms/IconScale.svelte";
  import Bullet from "../components/Bullet.svelte";
  import Bullets from "../components/Bullets.svelte";
  import CTAs from "../components/CTAs.svelte";
  import H1 from "../components/H1.svelte";
  import P from "../components/P.svelte";
  import LicenseChip from "../components/LicenseChip.svelte";
  import Slide from "../components/Slide.svelte";

  import { getIconProps, style } from "../utils";
  const license = "outreach";
  const iconProps = getIconProps(license);
</script>

<Slide>
  <LicenseChip {style} {license} />
  <H1>Insights that drive success</H1>
  <P>
    In-depth reports give you the clearest possible view of how you and your
    team are performing, enabling you to make better, data-driven decisions.
  </P>
  <Bullets>
    <Bullet>
      <IconScale class="fa-lightbulb" {...iconProps} />Get a clear understanding
      of engagement and performance
    </Bullet>
    <Bullet>
      <IconScale class="fa-refresh" {...iconProps} />Replicate successful
      strategies and identify areas for improvement
    </Bullet>
    <Bullet>
      <IconScale class="fa-brain" {...iconProps} />Improved decision making
    </Bullet>
  </Bullets>
  <CTAs tourLink="https://sourcewhale.navattic.com/r1o0ssw" />
</Slide>
